import { render, staticRenderFns } from "./DictionariesStart.vue?vue&type=template&id=26037cb8&"
import script from "./DictionariesStart.vue?vue&type=script&lang=js&"
export * from "./DictionariesStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports